import { AxiosRequestConfig } from 'axios';
import { IItemLookup } from 'src/common/interfaces/dtos/IItemLookup';
import { emeraldRequest } from '../../../common/api/emerald-request';
import { IScanData } from '../../../common/interfaces/dtos/IScanData';
import { EmeraldRequestParams } from '../../../common/interfaces/requests/EmeraldRequestParams';
export interface IProductLookupOrder {
  By: ProductListingSearchOrder;
  Direction: ProductListingSearchDirection;
}

export interface ISellQuantity {
  units: number;
  unitOfMeasureCode: string;
  value: number;
}

export enum ProductListingSearchOrder {
  ByProduct = 'SearchPanel_Product_Name',
  ByDepartment = 'SearchPanel_Department',
}

export enum ProductListingSearchDirection {
  Ascending = 'Ascending',
  Descending = 'Descending',
}

export interface IItemLookupCriteria {
  description?: string;
  scanData?: IScanData[];
  storeId?: string;
  pageNumber?: number;
  pageSize?: number;
  entryMethod?: string;
  actionDescription?: string;
  transactionId?: string;
  descriptionTypeFilter?: string;
  displayOnlyItemsInVariety?: boolean;
  displayItemsWithIdentifier?: boolean;
  quantity?: ISellQuantity;
  sortBy?: string;
  sortDirection?: string;
  scanCode?: string;
  groupId?: string;
}

export interface IGetProductListingsResponse {
  total: number;
  productListings: IItemLookup[];
}

export const getProductListings = async (
  searchParams: IItemLookupCriteria,
): Promise<IGetProductListingsResponse> => {
  const axiosConfig: AxiosRequestConfig = {
    method: 'GET',
    url: `/items`,
    params: searchParams,
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: false,
    showLoggingInfo: true,
  };

  return emeraldRequest<IGetProductListingsResponse>(emeraldRequestParams);
};
